import React from 'react';

import LoginForm from './LoginForm';
import LoginLostPasswordForm from './LoginLostPasswordForm';
import LoginRegisterForm from './LoginRegisterForm';
import LoginResetPassword from './LoginResetPassword';
import Footer from '../Footer.js'

class Login extends React.Component {

	constructor(props) {
	    super(props);
	    this.state = { form: this.props.form!==undefined?this.props.form:"LoginForm"};
	  }

	setCurrentForm(f){
		console.log(f,this.state);
		this.setState({form:f});
	}

  render () {
	  const form = this.state.form;

		return (
			<div className="container-fluid mt-5">
				<div className="row justify-content-center">
					<div className="col col-sm-12 col-md-10  col-lg-8 col-xl-6">
							{form === "LoginForm"?<LoginForm login={this} guppyi={this.props.guppyi}/>:""}
							{form === "LoginLostPasswordForm"?<LoginLostPasswordForm login={this} guppyi={this.props.guppyi}/>:""}
							{form === "LoginRegisterForm"?<LoginRegisterForm login={this} guppyi={this.props.guppyi}/>:""}
							{form === "LoginResetPassword"?<LoginResetPassword login={this} guppyi={this.props.guppyi}/>:""}
					</div>
				</div>
				<Footer/>
			</div>
		)
  }
}
export default Login;
